import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarriersForAssignmentMulticompany extends Layout {
    sourceCarriersForAssignment: DataSource;
    tableCarriersForAssignment: Table;
}
